<template>
  <div class="home-wrap">
    <router-view/>
  </div>
</template>

<script type="text/javascript">
  export default {
    name: 'home',
    data(){
      return {

      }
    },
    methods:{
    },
    components:{
    }
   }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/lib-variable";
  @import "../../assets/css/lib-mixin";

  .home-wrap{
    padding: 20px;
    width: 100%;
    box-sizing: border-box;
  }

</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue